<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }" style="margin-top: 75px">
    <TheAsideBarMenu />
    <CWrapper class="justify-content-between">
      <div>
        <TheHeader />
        <main class="justify-content-between position-relative">
          <CContainer>
            <CWrapper class="justify-content-between">
              <ToastMessage />
              <router-view :key="$route.path"></router-view>

              <CookieBanner v-if="CookieBannerVisible" />
              <MobileWarning v-if="isMobile" />
            </CWrapper>
          </CContainer>
        </main>
      </div>
      <TheFooter />
    </CWrapper>
  </div>
</template>

<script>
import ToastMessage from '@/components/ToastMessage'
import CookieBanner from '@/components/CookieBanner'
import MobileWarning from '@/components/MobileWarning'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheAsideBarMenu from './TheAsideBarMenu'

export default {
  name: 'TheContainer',
  components: {
    ToastMessage,
    TheHeader,
    TheFooter,
    TheAsideBarMenu,
    CookieBanner,
    MobileWarning,
  },
  data() {
    return {
      CookieBannerVisible: true,
    }
  },
  computed: {
    isMobile() {
      return /Mobi|Android|iPhone/i.test(navigator.userAgent)
    },
  },
  created() {
    //TODO melhorar evitar que se tenha que enviar isso para zerar o setToastMessage
    this.$store.commit('setToastMessage', null)
    // temporario
    var value = sessionStorage.getItem('useCookie')
    if (value) {
      this.CookieBannerVisible = false
    }
  },
}
</script>

<style></style>
